import classnames from "classnames";
import React, { Fragment } from "react";

import { useBreakpoint } from "@utils/breakpoints/breakpoints.provider";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";
import { Clamp } from "@components/General/Clamp/clamp.component";

import "./text.scss";

type Props = {
    text: string;
    color: string;
    readMoreMobile: boolean;
    readMoreDesktop: boolean;
};

const TextComponent = ({
    text,
    color,
    readMoreMobile,
    readMoreDesktop,
}: Props) => {
    const { t } = useGranite();
    const { breakpoints } = useBreakpoint();

    let clampEnabled = readMoreDesktop && readMoreMobile;
    if (!clampEnabled) {
        clampEnabled = breakpoints.md ? readMoreDesktop : readMoreMobile;
    }

    return (
        <Fragment>
            {clampEnabled && (
                <Clamp
                    lines={4}
                    withToggle
                    showMoreElement={({ toggle }: any) => (
                        <Button
                            type={"button"}
                            color={"link"}
                            className={classnames("p-0", "mb-3")}
                            onClick={toggle}
                        >
                            {t("textComponent.link.showMore")}
                            <i className={"las la-angle-down ml-1"} />
                        </Button>
                    )}
                    showLessElement={({ toggle }: any) => (
                        <Button
                            type={"button"}
                            color={"link"}
                            className={classnames("p-0", "mb-3")}
                            onClick={toggle}
                        >
                            {t("textComponent.link.showLess")}
                            <i className={"las la-angle-up ml-1"} />
                        </Button>
                    )}
                >
                    <div
                        className={classnames("rich-text-content", color)}
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                </Clamp>
            )}
            {!clampEnabled && (
                <div
                    className={classnames("rich-text-content", color)}
                    dangerouslySetInnerHTML={{ __html: text }}
                />
            )}
        </Fragment>
    );
};

export default TextComponent;
